import { render, staticRenderFns } from "./campdetails.vue?vue&type=template&id=fdb20912&scoped=true"
import script from "./campdetails.vue?vue&type=script&lang=js"
export * from "./campdetails.vue?vue&type=script&lang=js"
import style1 from "./campdetails.vue?vue&type=style&index=1&id=fdb20912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb20912",
  null
  
)

export default component.exports